import { Component, OnInit, Input } from '@angular/core';
import { ProcedureSevenService } from '../../services/procedures/procedure-seven.service';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import {environment} from '../../../environments/environment';
import {FilesService} from "../../services/files.service";

@Component({
  selector: 'ngx-procedure-seven',
  templateUrl: './procedure-seven.component.html',
  styleUrls: ['./procedure-seven.component.scss'],
})

export class ProcedureSevenComponent implements OnInit {

  @Input() stationId: string;

  state = 'Actividades';

  attrAux = {
    trackingRecord: {
      data: [],
      loading: false,
      file: false,
    },
    analisys: {
      data: [],
      loading: false,
      file: false,
    },
  };

  documents = {
    comunication: '',
    registration: '',
    analysis: '',
  };

  downloading = false;

  constructor(
    private procedureService: ProcedureSevenService,
    private fileService: FilesService,
  ) { }

  onChangeTab(event) {
    this.state = event.tabTitle;
  }

  ngOnInit() {
    this.generateDocument();
    this.getDataTrackingRecord();
    this.getDataAnalisys();
  }

  loadImage (evt: any, activity: string) {
    if (!evt.target.files.length) return;
    this.attrAux[activity].file = evt.target.files[0];
  }

  async getDataTrackingRecord() {
    this.attrAux.trackingRecord.loading = true;
    const [error, { data: result }] = await this.procedureService.getDataActivity(this.stationId, 'trackingRecord');
    this.attrAux.trackingRecord.loading = false;
    if (error) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    this.attrAux.trackingRecord.data = result;
    console.error(result);
  }

  async getDataAnalisys() {
    this.attrAux.analisys.loading = true;
    const [error, { data: result }] = await this.procedureService.getDataActivity(this.stationId, 'analisys');
    this.attrAux.analisys.loading = false;
    if (error) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    this.attrAux.analisys.data = result;
  }

  async store(activity: string) {
    if (!this.attrAux[activity].file) return this.alert('Oops, algo ocurrio, intenta más tarde', 'error');
    this.attrAux[activity].loading = true;
    const data = new FormData();
    data.append('file', this.attrAux[activity].file);
    const [error] = await this.procedureService.store(this.stationId, data, activity);
    this.attrAux[activity].loading = false;
    if (error) return this.alert('Ha ocurrido un error al cargar el archivo, por favor intenta más tarde', 'error');
    if (activity === 'trackingRecord') return this.getDataTrackingRecord();
    return this.getDataAnalisys();
  }

  async generateDocument() {
    this.documents.comunication = `${environment.baseEndpoint}/filesGeneratorv2/implementation/seven/comunication/${this.stationId}`;
    this.documents.registration = `${environment.baseEndpoint}/filesGeneratorv2/implementation/seven/registration/${this.stationId}`;
    this.documents.analysis = `${environment.baseEndpoint}/filesGeneratorv2/implementation/seven/analysis/${this.stationId}`;
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name.toLowerCase().replace(' ', '_'));
    this.downloading = false;
  }
}
